import Time        from './Utils/Time.js'
import Sizes       from './Utils/Sizes.js'
import Input       from './Utils/Input.js'
import Camera      from './Camera.js'
import Renderer    from './Renderer.js'
import Environment from './Environment/Environment.js'

export default {
    Time,
    Sizes,
    Input,
    Camera,
    Renderer,
    Environment
}